// AppRoutes.ts
import React from 'react';
import LandingLayout from '../Components/Layout/LandingLayout/LandingLayout';
import Landing from '../Components/Content/Landing/Landing';
import RequestAccountDeletionPage from '../Pages/RequestAccountDeletion';
import { AppRoute } from './Models/AppRoute';

const AppRoutes: AppRoute[] = [
    {
        path: '/',
        element: <Landing />,
        layout: LandingLayout,
        hideInMainMenu: true,
    },
    {
        path: '/RequestAccountDeletion',
        element: <RequestAccountDeletionPage />,
        layout: LandingLayout,
        hideInMainMenu: true,
    },
];

export { AppRoutes };